import { GateRules, GraphDimension, RegistrationViewConfigResponse, Schedule } from '@dr-customer-offers-ui/lib-interfaces';
import { NgxIntervalDataGridRowModel, OperationalHours } from '@ngx-interval-data-grid';
import { NgxDateRangePickerOutput } from 'ngx-date-range-picker';
import { DaterangeISO } from './daterange';
import { MinuteFrequencyOptionEnum } from './tab.model';

export interface TabDisplayInterface {
  display_schedule_tab: boolean;
  display_cleared_tab: boolean;
  display_baselines_tab: boolean;
  display_da_tab: boolean | null;
}
export interface RegConfig {
  programId: string;
  productId: string;
  registrationId: string;
  timeZone: string;
  minimumValue: number;
  maximumValue: number;
  lockedOut: boolean;
  intervalFrequency: MinuteFrequencyOptionEnum;
  isSet: boolean;
  tab_display: TabDisplayInterface;
  display_labels: string;
  gateRules: GateRules;
  operational_hours?: OperationalHours[];
  graph_view: boolean;
  override_ignore_gate_rules: boolean;
  allow_bulk_upload: boolean;
  minimum_baseline_value?: number;
  maximum_baseline_value?: number;
  graph_config: GraphConfig | null;
  allow_cleared_offers_bulk_upload: boolean;
  enable_opt_out: boolean;
}

export interface GraphConfig {
  consolidate_dimensions_into_hourly: GraphDimension[] | null;
  offer_dimensions: GraphDimension[];
}

export interface GroupedData {
  values: NgxIntervalDataGridRowModel[] | null;
  regConfig: RegConfig | null;
  selectedDateRange?: NgxDateRangePickerOutput;
}

export interface OffersDataInterface {
  values: NgxIntervalDataGridRowModel[] | null;
  selectedDateRange?: DaterangeISO;
}

function getIntervalFrequency(schedule: Schedule): MinuteFrequencyOptionEnum {
  if (schedule.offer_frequency_unit === 'MINUTES') {
    return schedule.offer_frequency as MinuteFrequencyOptionEnum;
  } else if (schedule.offer_frequency_unit === 'HOURS') {
    return (schedule.offer_frequency * 60) as MinuteFrequencyOptionEnum;
  } else if (schedule.offer_frequency_unit === 'DAYS') {
    return (schedule.offer_frequency * 1440) as MinuteFrequencyOptionEnum;
  } else {
    return 60 as MinuteFrequencyOptionEnum;
  }
}

export function transformRegConfig(regConfigResponse: RegistrationViewConfigResponse, userLocale: string): RegConfig {
  return {
    programId: regConfigResponse.program_id,
    productId: regConfigResponse.product_id,
    registrationId: regConfigResponse.id,
    timeZone: regConfigResponse.timezone,
    minimumValue: regConfigResponse.minimum_value,
    maximumValue: regConfigResponse.maximum_value,
    lockedOut: regConfigResponse.locked_out,
    intervalFrequency: getIntervalFrequency(regConfigResponse.schedule),
    isSet: regConfigResponse.is_set,
    tab_display: regConfigResponse.tab_display,
    display_labels:
      regConfigResponse.display_labels[userLocale] ??
      regConfigResponse.display_labels['en_US'] ??
      regConfigResponse.display_labels?.[Object.keys(regConfigResponse.display_labels || {})[0]] ??
      '',
    gateRules: regConfigResponse.gate_rules,
    operational_hours: regConfigResponse.operational_hours,
    graph_view: regConfigResponse.graph_view,
    maximum_baseline_value: regConfigResponse.maximum_value,
    minimum_baseline_value: regConfigResponse.minimum_value,
    override_ignore_gate_rules: regConfigResponse.override_ignore_gate_rules,
    allow_bulk_upload: regConfigResponse?.allow_bulk_upload ?? false,
    graph_config: regConfigResponse.graph_config,
    allow_cleared_offers_bulk_upload: regConfigResponse?.allow_cleared_offers_bulk_upload ?? false,
    enable_opt_out: regConfigResponse?.enable_opt_out ?? true
  };
}
